(function(){
  'use strict';
  // Countdown to tonight's 9 PM bottling cutoff; rolls to the next day after 9 PM.
  var cd = document.getElementById('cd');
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var now = new Date();
    var t = new Date(now); t.setHours(21, 0, 0, 0);
    if (now >= t) t.setDate(t.getDate() + 1);
    var s = Math.floor((t - now) / 1000);
    cd.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
  }
  tick(); setInterval(tick, 1000);

  // Bottom CTA pops after two viewports of scroll.
  var pop = document.getElementById('popcta');
  function onScroll(){
    if (window.scrollY > window.innerHeight * 2) pop.classList.add('on');
    else pop.classList.remove('on');
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  // Meta Pixel event on every CTA click. Same pixel as the live funnel.
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-plink]') && window.fbq) {
      window.fbq('track', 'ViewContent', {content_name:'Humpy Journal CTA', currency:'INR'});
    }
  });
})();

/* Meta Pixel initialization from source funnel */
!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init','575630972822396');fbq('track','PageView');
